module.exports = __webpack_public_path__ + "static/media/tradecraft-patterns.9460621a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/tradecraft-patterns.png
// module id = 480
// module chunks = 0